import React from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import { Card } from "./ui/Card";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { mediaQuery } from "react-styled-mediaquery";
import { DottedLink } from "./ui/DottedLink";
import { Link } from "react-scroll";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IconExportCustom, IconExportStandard } from "../icons-ts";
import { colors } from "../lib/constant";
import { fontFamily, fontSize, product_sans } from "../lib/fonts";

const IlluCommunication = require("../../assets/illustrations/communication.png");

const SectionPriceTitle = styled(Col)`
  text-align: center;

  ${mediaQuery("<", "desktop")`
    text-align: left;
  `}
`;

const Container = styled(Row)`
  margin-top: 100px;

  ${mediaQuery("<=", "desktop")`
    margin-top: 40px;
  `}
  ${mediaQuery("<=", "tablet")`
    margin-top: 10px;
  `}
`;

const CardItem = styled(Col)`
  display: flex !important;
`;

const ImgConnection = styled(LazyLoadImage)`
  display: block;
  width: 100%;
`;

const ScrollLink = styled(Link)`
  cursor: pointer;
`;

const Include = styled.div`
  ${fontSize("13px")}
  line-height: 18px;
  ${fontFamily(product_sans.medium)};
  color: ${colors.grey};
`;

export const SectionFeaturesConnection = () => {
  return (
    <>
      <Row center="xs" id="connectionContainer">
        <SectionPriceTitle xs={12} md={8}>
          <Title htmlLevel={2} theme="titleBodyStyle">
            Des données immédiatement centralisées
          </Title>

          <Paragraph>
            Récupérez régulièrement, sur demande ou en temps réel, les
            signatures récoltées. Notre plateforme propose des solutions
            d’intégrations avec tout type de CRM. Nous communiquons déjà
            régulièrement avec Salesforce, Bisnode, Actito, Espadon, Clixray,...
          </Paragraph>
        </SectionPriceTitle>
      </Row>

      <Container between="xs" middle="xs">
        <Col xs={12} md={6} lg={6}>
          <Row>
            <CardItem xs={12} sm={6}>
              <Card
                icon={<IconExportStandard width="50" fill={colors.primary} />}
                label="Exports standardisés"
                desc="La plateforme prévoit, en clé sur porte, un export quotidien des données et des bulletins signés vers un espace sécurisés sous un format standardisé."
              >
                <ScrollLink
                  to="price"
                  spy={true}
                  smooth={true}
                  duration={700}
                  offset={-100}
                >
                  <Include>Inclus dans les offres</Include>
                </ScrollLink>
              </Card>
            </CardItem>

            <CardItem xs={12} sm={6}>
              <Card
                icon={<IconExportCustom width="50" fill={colors.primary} />}
                label="Exports personnalisés"
                desc="La plateforme permet, à la demande, d’exporter des formats non standardisés ou de communiquer en direct via WebServices."
              >
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={700}
                  offset={-100}
                >
                  <DottedLink fontsize={"13px"}>Contactez-nous</DottedLink>
                </Link>
              </Card>
            </CardItem>
          </Row>
        </Col>

        <Col xs={false} md={5} lg={5}>
          <ImgConnection
            src={IlluCommunication}
            alt="Illustration communication"
            effect="opacity"
            threshold={300}
          />
        </Col>
      </Container>
    </>
  );
};
